// Definición de un componente funcional
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import React, {useContext, useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import { KeycloakContext } from "../../context/KeycloakContext";
import DataRanges from "./Tabs/DataRanges";
import Annual from "./Tabs/Annual";
import FormFilterMultiSelect from "../Form/FormFilterMultiSelect";
import {getStatisticsChunked, getStatisticsTotal} from "../../helpers/ApiRequests";
import { formatLocalDateToISO } from "../../helpers/FormatDate";
import {FlashingBorder} from "../../Shared/FlashingBorder";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const Statistics = () => {
    const { kc } = useContext( KeycloakContext )

    const { appInsights } = useContext( KeycloakContext )
    const { t } = useTranslation();
    const [ activeIndex, setActiveIndex ] = useState(0)
    const [ activeTabs, setActiveTabs ] = useState(() => false)
    const [ activeCalendar, setActiveCalendar ] = useState(false)

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [ statisticsTotalData, setStatisticsTotalData] = useState(null);
    const [ statisticsTotalSelectedUser, setStatisticsTotalSelectedUser ] = useState(null);
    const [ statisticsTotalUsers, setStatisticsTotalUsers ] = useState(null);

    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedTimeChunk, setSelectedTimeChunk] = useState('WEEK');
    const [users, setUsers] = useState([]);
    const [statisticsData, setStatisticsData] = useState([]);
    const [isVisible, setIsVisible] = useState(true);


    const getStatisticsData = async () => {
        const data = await getStatisticsChunked( kc, selectedTimeChunk )
        if ( data ) {
            const obj = changeKyeObject(data)
            setStatisticsData(obj)
            setUsers(Object.keys(obj));
            if (Object.keys(data).length > 0 && !selectedUser) {
                setSelectedUser(Object.keys(obj)[0]);
            }
        }
    }

    function changeKyeObject(data) {
        const obj = {};
        for (let key in data) {
            obj[key.split(' ').slice(0,3).join(' ')] = data[key];
        }
        return obj;
    }

    const loadStatisticsTotal = async () => {

        const params = new URLSearchParams();
        if (startDate) params.append('startdate', formatLocalDateToISO(startDate));
        if (endDate) params.append('enddate', formatLocalDateToISO(endDate));

        const data = await getStatisticsTotal( kc, params )
        if ( data ) {
            setStatisticsTotalData(data)
            setStatisticsTotalUsers(Object.keys(data))
            if (Object.keys(data).length > 0 && !selectedUser) {
                setStatisticsTotalSelectedUser(Object.keys(data)[0]);
            }
        }

    }


    useEffect( () => {
        loadStatisticsTotal()
    }, [startDate, endDate]);

    useEffect( () => {
        getStatisticsData()
    }, [selectedTimeChunk, kc, baseUrl]);

    const newDateValues = (event) => {
        setStartDate(event[0])
        setEndDate(event[1])
    }

    const setActiveTab = (newTab) => {
        if (newTab.index === 0) setActiveCalendar(true)
        setActiveTabs(true)
        setActiveIndex(newTab.index); // Aktualisiert den Zustand mit dem neuen Tab
        if (appInsights) {
            appInsights.trackPageView({ name: newTab.name });
        }
    };

    const handleAnimationEnd = () => {
        setIsVisible(false);
    };

    return (
        <div className='container-page mx-auto relative z-1 p-1 overflow-y-hidden overflow-x-hidden'>
            <div className="container-flash-border mx-auto  pt-3 pr-2 pl-2 pb-0 sm:pt-4 sm:pr-4 sm:pl-4 border-1 border-white z-1 flex flex-column overflow-auto">
                {isVisible && (
                    <>
                        <FlashingBorder flash={'flash-border'} onAnimationEnd={handleAnimationEnd} />
                    </>
                )}
                <div className="flex flex-wrap sm:flex justify-content-between">
                    <div className="text-xl my-1 mr-3 lg:my-2 lg:my-0 lg:text-3xl text-white uppercase">
                        { activeTabs && (
                                <li onClick={ () => setActiveTabs(false)} className="text-md lg:text-xl cursor-pointer mr-4 pi pi-arrow-left color-primary" />
                        )}
                        {t('Statistics')}
                    </div>
                    { activeTabs && (
                        <div className="pb-2 my-1 lg:my-2 lg:pb-2 lg:my-0 ">
                            <FormFilterMultiSelect
                                showCalendar={ activeCalendar }
                                newDateValues={ newDateValues }
                                selectedUser={ activeCalendar ? statisticsTotalSelectedUser : selectedUser }
                                setSelectedUser={ activeCalendar ? setStatisticsTotalSelectedUser : setSelectedUser }
                                users={ activeCalendar ? statisticsTotalUsers : users }
                                rangeDate={[startDate, endDate]}
                            />
                        </div>
                    )}
                </div>
                { !activeTabs ? (
                    <div className="flex flex-1 justify-content-center align-items-center flex-column mt-4 border-t">
                        <div className="relative w-8/12 md:w-4/12 lg:w-2/12 mb-4">
                            <Button onClick={ () => setActiveTab({ name: 'data-range', index: 0 } )} className="btn-1 w-full py-3 sm:py-4 text-sm justify-content-center" style={{ borderRadius: 32 }} >{ t('by-date-range') }</Button>
                        </div>
                        <div className="relative w-8/12 md:w-4/12 lg:w-2/12">
                            <Button onClick={ () => setActiveTab({ name: 'annual', index: 1 } )} className="btn-1 w-full py-3 sm:py-4 text-sm justify-content-center" style={{ borderRadius: 32 }}>{ t('annual') }</Button>
                        </div>
                    </div>
                ) : (
                    <div className="card patient-tabs h-5/6" style={{Height: 90}}>
                        <TabView activeIndex={activeIndex} className="h-full"  onTabChange={(e) => {
                            setActiveIndex(e.index)
                            e.index === 0 ? setActiveCalendar(true) : setActiveCalendar(false)
                        }}>
                            <TabPanel className="h-full" contentClassName={'date-tab'} header={ t('by-date-range') }>
                               <DataRanges
                                   data={ statisticsTotalData }
                                   selectedUser={ statisticsTotalSelectedUser }
                               />
                            </TabPanel>
                            <TabPanel header={ t('annual') }>
                               <Annual
                                   data={statisticsData}
                                   selectedTimeChunk={selectedTimeChunk}
                                   setSelectedTimeChunk={setSelectedTimeChunk}
                                   selectedUser={selectedUser}
                               />
                            </TabPanel>
                        </TabView>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Statistics;
